export const WEB_VERSION = __APP_VERSION__;
